import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { useParams, Link } from 'react-router-dom';
import { videos, categories } from '@/mocks/videos';
import { useState, useEffect } from 'react';

const categoryNames: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  jilupian: '纪录片',
  dongman: '动漫',
};

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [selectedCat, setSelectedCat] = useState(slug || 'dianying');
  const categoryVideos = videos.filter((v) => v.category === selectedCat);
  const currentCategory = categoryNames[selectedCat] || '未知分类';
  const catInfo = categories.find((c) => c.slug === selectedCat);

  useEffect(() => {
    if (slug && categories.some((c) => c.slug === slug)) {
      setSelectedCat(slug);
    }
  }, [slug]);

  useEffect(() => {
    document.title = `${currentCategory} - 九九免费视频`;
  }, [currentCategory]);

  const handleVideoClick = (id: string) => {
    window.REACT_APP_NAVIGATE(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <section className="bg-background-100 py-8 md:py-12 px-4 md:px-6">
          <div className="max-w-[1920px] mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-800 font-medium">{currentCategory}</span>
            </nav>

            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              {currentCategory}
            </h1>
            {catInfo && (
              <p className="mt-2 text-sm md:text-base text-foreground-500">{catInfo.description}</p>
            )}

            <div className="flex items-center gap-2 mt-6 overflow-x-auto pb-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                    selectedCat === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 md:py-10 px-4 md:px-6">
          <div className="max-w-[1920px] mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
              {categoryVideos.map((video) => (
                <div
                  key={video.id}
                  className="group cursor-pointer"
                  onClick={() => handleVideoClick(video.id)}
                  data-product-shop=""
                >
                  <div className="relative aspect-video overflow-hidden rounded-xl mb-3">
                    <img
                      src={video.image}
                      alt={video.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                    <div className="absolute top-3 right-3">
                      <span className="px-2 py-1 bg-black/70 backdrop-blur-sm text-white text-xs font-label rounded-md">
                        {video.duration}
                      </span>
                    </div>
                    <div className="absolute top-3 left-3">
                      <span className="px-2 py-1 bg-accent-500 text-background-50 text-xs font-bold font-label rounded-md flex items-center gap-1">
                        <i className="ri-star-fill text-[10px]"></i>
                        {video.rating}
                      </span>
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                        <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                      </div>
                    </div>
                  </div>
                  <h3 className="font-heading font-bold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {video.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                    <span className="text-xs text-foreground-400">{video.updateTime} 更新</span>
                  </div>
                </div>
              ))}
            </div>

            {categoryVideos.length === 0 && (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-foreground-300 text-5xl"></i>
                <p className="mt-4 text-foreground-500">该分类暂无内容</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}